import React, { Component } from 'react';
import {
    Alert, Button, Spinner, Table,
} from 'react-bootstrap';
import { PageStatus } from 'enums';
import { Show } from "../../Layout";
import CardHeader from "../Card/CardHeader";
import GridContainer from "../Grid/GridContainer";
import moment from "moment/moment";
import { exportToExcel } from "../../Utils/ExportToExcel";
import { AuthAPI } from "../../API";
import { Confirmation } from "../../Shared/Confirmation";
import ShowDataAccording2PageSize from '../ShowEntries/ShowEntries';
import PaginationNumbering from '../ShowEntries/Pagination';
import csvtojson from 'csvtojson';
import { formatSmartDate } from "../../Utils/DateFormatter";


const MODAL_TYPES = {
    NONE: 'NONE',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    DETAILS: 'DETAILS',
};

type State = {
    status: PageStatus,
    error: string | null,
    formType: string,
    data: any[],
    id?: string | null,
    filteredData: any[],
    filters: {
        userId: '',
        email: '',
        phoneNumber: ''
    },
    pageSize: any,
    currentPageNumber: any,
    totalResponseData: any,
    totalResponsePages: any,
    loading: any,
    bulkImportData: any[],
};

export class DeletedPanelistsOnly extends Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            status: PageStatus.None,
            error: null,
            formType: MODAL_TYPES.NONE,
            data: [],
            id: null,
            filteredData: [],
            filters: {
                userId: '',
                email: '',
                phoneNumber: ''
            },
            pageSize: 10,
            currentPageNumber: 1,
            totalResponseData: '',
            totalResponsePages: '',
            loading: false,
            bulkImportData: [],
        };
        this.fetchList = this.fetchList.bind(this);
    }

    componentDidMount() {
        this.fetchList()
    }

    fetchList(): Promise<void> {
        const { pageSize, currentPageNumber, filters } = this.state;
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => AuthAPI.usersList(pageSize, currentPageNumber, filters, 'deleteRequestOnly'))
            .then((users) => {
                let responseData: any = users;
                this.setState({ data: responseData.data, filteredData: responseData.data, totalResponseData: responseData.totalCount, totalResponsePages: responseData.totalPage, status: PageStatus.Loaded });
            })
            .catch((error) => {
                this.setState({ error: error.message, status: PageStatus.Error });
            });
    }


    handleFilterChange = (e) => {
        const { name, value } = e.target;
        this.setState(
            (prevState) => ({
                filters: {
                    ...prevState.filters,
                    [name]: value.trim(),
                },
            }),
        );
    };

    applyFilters = () => {
        if (this.state.currentPageNumber == 1) { this.fetchList(); return; }
        this.setState({ currentPageNumber: 1 })
    };

    clearFilter = async () => {
        await new Promise((resolve: any) =>
            this.setState({
                filters: {
                    userId: '',
                    email: '',
                    phoneNumber: ''
                },
                pageSize: 10,
                currentPageNumber: 1,
                totalResponseData: '',
                totalResponsePages: ''
            }, resolve));
        this.fetchList();
    }

    bulkDeleteRequest = async () => {
        let rejectObject = { "rejectList": this.state.bulkImportData };
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => AuthAPI.deleteBulkUserRequests(rejectObject))
            .then((respo) => {
                this.fetchList();
                alert(respo);
                return this.setState({ status: PageStatus.Loaded });
            })
            .catch((error) => {
                this.setState({ error: error.message, status: PageStatus.Error });
            });
    }

    handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) {
            this.setState({ bulkImportData: [] });
            return;
        }
        try {
            const jsonData = await this.convertCsvToJson(file);
            let transformedData = jsonData.map(this.modifiedConvertedJson);
            transformedData = transformedData.filter(ele => ele != undefined);
            if (transformedData.length < 1) {
                alert("Type column is missing in file.");
                transformedData = [];
            }
            this.setState({ bulkImportData: transformedData })
        } catch (error) {
            console.error('Error converting CSV to JSON:', error);
        }
    };

    convertCsvToJson = (file: File): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const csvContent: any = reader.result;
                if (!csvContent.trim()) {
                    reject(new Error('CSV content is empty.'));
                    return;
                }
                csvtojson().fromString(csvContent).then(jsonData => resolve(jsonData))
            };
            reader.onerror = (event) => {
                const message = reader.error?.message ?? 'Unknown error during file reading';
                reject(new Error(message));
            };
            reader.readAsText(file);
        });
    };

    modifiedConvertedJson = (obj) => {
        if (obj.type == "delete") {
            return {
                userId: obj.userId,
                type: obj.type,
            };
        }
    }

    async handleExport() {
        this.setState({ loading: true });
        const { currentPageNumber, filters } = this.state;
        try {
            const recievedData = await AuthAPI.usersList('All', currentPageNumber, filters, 'deleteRequestOnly', { responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([recievedData]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'deletedPanelistsOnly.xlsx');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error exporting data:", error);
        } finally {
            this.setState({ loading: false });
        }
    };

    deleteAcceptActions(id): Promise<void> {
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => AuthAPI.deleteActions(id, 'accept'))
            .then((users) => {
                this.fetchList()
                this.setState({ data: users, status: PageStatus.Loaded });
            })
            .catch((error) => {
                this.setState({ error: error.message, status: PageStatus.Error });
            });
    }

    deleteRejectActions(id): Promise<void> {
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => AuthAPI.deleteActions(id, 'reject'))
            .then((users) => {
                this.fetchList()
                this.setState({ data: users, status: PageStatus.Loaded });
            })
            .catch((error) => {
                this.setState({ error: error.message, status: PageStatus.Error });
            });
    }

    handlePageSizeChange = (newValue: any) => { this.setState({ pageSize: newValue, currentPageNumber: 1 }); };
    handlePageNumberChange = (newValue: any) => { this.setState({ currentPageNumber: newValue }); };

    componentDidUpdate(prevProps: {}, prevState: State) {
        if (prevState.pageSize !== this.state.pageSize || prevState.currentPageNumber !== this.state.currentPageNumber) { this.fetchList(); }
    };

    render() {
        const { filters, pageSize, currentPageNumber, totalResponseData, totalResponsePages } = this.state;
        return (
            <>
                <GridContainer>
                    <div className='w-100 mb-3'>
                        <CardHeader color="primary">
                            <div className="d-flex align-items-center justify-content-between">
                                <h4>Delete Request Panelists</h4>
                            </div>
                        </CardHeader>
                    </div>
                </GridContainer>

                <div className="jumbotron bg-white p-3 border shadow-sm">
                    <div className='mb-3'>Filter</div>

                    <form>
                        <div className="row">
                            <div className="col">
                                <label htmlFor='userId'>User ID</label>
                                <input type="text"
                                    className="form-control"
                                    placeholder="Enter..."
                                    name="userId"
                                    value={filters.userId}
                                    onChange={this.handleFilterChange}
                                />
                            </div>
                            <div className="col">
                                <label htmlFor='email'>Email</label>
                                <input type="email"
                                    className="form-control"
                                    placeholder="Enter..."
                                    name="email"
                                    value={filters.email}
                                    onChange={this.handleFilterChange}
                                />
                            </div>
                            <div className="col">
                                <label htmlFor='phoneNumber'>Phone Number</label>
                                <input type="text"
                                    className="form-control"
                                    placeholder="Enter..."
                                    name="phoneNumber"
                                    value={filters.phoneNumber}
                                    onChange={this.handleFilterChange}
                                />
                            </div>
                        </div>
                    </form>

                    <div className="jumbotron bg-white p-1 mt-2 shadow-sm">
                        <button type="button" className="btn btn-success" onClick={() => this.applyFilters()}>Filter Panelists</button>
                        <button type="button" className="btn btn-info ml-1" onClick={() => this.handleExport()}>Export</button>
                        <button type="button" className="btn btn-danger ml-1" onClick={() => this.clearFilter()}>Clear Filter</button>
                        <div>
                            <input className="mt-2" type="file" accept=".csv" onChange={(e) => this.handleFileChange(e)} />
                        </div>
                        <div>
                            <Confirmation onAction={() => this.bulkDeleteRequest()} body="Are you sure want to bulk delete requests ?">
                                <Button
                                    variant="primary"
                                    disabled={this.state.bulkImportData.length === 0}
                                    className="mt-3"
                                    size="sm"
                                >
                                    Approve Bulk Delete Request
                                </Button>
                            </Confirmation>
                        </div>
                    </div>


                </div>

                <div className="jumbotron bg-white p-3 border shadow-sm">
                    <Alert variant="danger" show={this.state.status === PageStatus.Error}>
                        {this.state.error}
                    </Alert>

                    <Show when={this.state.status === PageStatus.Loading}>
                        <div className="d-flex justify-content-center w-100 p-5">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    </Show>

                    <Show when={this.state.status === PageStatus.Loaded}>

                        <Show when={!this.state.filteredData.length}>
                            <Alert variant="info" show={!this.state.filteredData.length}>
                                No data is available
                            </Alert>
                        </Show>

                        <Show when={!!this.state.filteredData.length}>
                            <div className='mb-2'>
                                <ShowDataAccording2PageSize
                                    currentPageSize={pageSize}
                                    currentPage={currentPageNumber}
                                    sendPageSize={this.handlePageSizeChange}
                                    showTotalData={totalResponseData}
                                    sendLastPage={totalResponsePages}
                                />
                            </div>
                            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '9999' }}>
                                {this.state.loading && (
                                    <img style={{ height: "415px", }}
                                        src="../loadernew.gif"
                                        alt="Loading..."
                                    />
                                )}
                            </div>
                            <Table responsive size="sm" bordered>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>User Id</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone Number</th>
                                        <th>City</th>
                                        <th>Date Of Birth</th>
                                        <th>CreatedAt</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        this.state.filteredData.map((info, index) => (
                                            <tr key={info.id}>
                                                <td>{((pageSize) * (currentPageNumber - 1)) + (index + 1)}</td>
                                                <td>{info.id}</td>
                                                <td className="text-start">
                                                    <button
                                                        type="button"
                                                        className="bg-transparent text-primary p-0 border-0 text-start d-block"
                                                        style={{ whiteSpace: "normal" }}
                                                        onClick={() => {
                                                            this.setState({
                                                                formType: MODAL_TYPES.NONE,
                                                                id: info.id,
                                                            });
                                                        }}
                                                    >
                                                        <div
                                                            style={{ textAlign: "left", display: "block", whiteSpace: "normal" }}
                                                            dangerouslySetInnerHTML={{
                                                                __html: info.firstName || info.lastName ? `${info.firstName} ${info.lastName}` : '-',
                                                            }}
                                                        ></div>
                                                    </button>
                                                </td>
                                                <td>{info.email ? info.email : "-"}</td>
                                                <td>{info.phoneNumber ? info.phoneNumber : "-"}</td>
                                                <td>{info.city ? info.city : '-'}</td>
                                                <td>{info.dateOfBirth ? formatSmartDate(info.dateOfBirth, false) : '-'}</td>
                                                <td>{formatSmartDate(info.createdAt)}</td>
                                                <td>
                                                    <Confirmation onAction={() => this.deleteAcceptActions(info.id)} body="Are you sure want to approve delete request ?">
                                                        <Button
                                                            variant="success"
                                                            size="sm"
                                                            disabled={info.deleteConfirmDate}
                                                            className="mx-1"
                                                        >
                                                            Approve
                                                        </Button>
                                                    </Confirmation>
                                                    <Confirmation onAction={() => this.deleteRejectActions(info.id)} body="Are you sure want to reject delete request ?">
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            disabled={info.deleteConfirmDate}
                                                            className="mx-1"
                                                        >
                                                            Reject
                                                        </Button>
                                                    </Confirmation>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>

                            </Table>
                            <div>
                                <PaginationNumbering
                                    currentPage={currentPageNumber}
                                    returnPagenumber={this.handlePageNumberChange}
                                    showTotalData={totalResponseData}
                                    sendLastPage={totalResponsePages}
                                />
                            </div>
                        </Show>
                    </Show>
                </div>
            </>
        );
    }
}
